import SystemStatus from './SystemStatus';

export default function StatusPage() {
  return (
    <div className="page-shell">
      <section className="hero-panel hero-panel--home">
        <div className="hero-copy">
          <p className="eyebrow">Visibilidad operativa</p>
          <h1>Estado de ESA Logística</h1>
          <p className="hero-text">
            Consulta la disponibilidad de la API y la base de datos. La información se actualiza automáticamente cada minuto.
          </p>
        </div>
      </section>
      <SystemStatus title="Estado del servicio" subtitle="Alertas y métricas verificadas contra el backend." />
    </div>
  );
}
